import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    productsWidgetGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: theme.spacing(0.75),
      alignItems: 'stretch',
      width: '100%',
    },
    productGridItem: {
      display: 'flex',
      minWidth: 0,
    },
  }),
  {index: 1},
);

export default useStyles;
